// Library Methods
import { createContext, useCallback, useContext, useState } from "react";

const ExamTransferContext = createContext({
  openTransferModal: false,
  transferExamId: "",
  transferPatient: { displayName: "", value: "" },
  actions: {
    handleTransferClick: (_: string) => {},
    handleTransferClose: () => {},
    setTransferPatient: (_: { displayName: string; value: string }) => {},
  },
});

export const useExamTransferContext = () => {
  const context = useContext(ExamTransferContext);
  if (!context) {
    throw new Error(
      "useExamTransferContext must be used within ExamTransferContextProvider"
    );
  }

  return context;
};

type ExamTransferProviderType = {
  children: React.ReactNode;
};

const ExamTransferProvider = ({ children }: ExamTransferProviderType) => {
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [transferExamId, setTransferExamId] = useState("");
  const [transferPatient, setTransferPatient] = useState({
    displayName: "",
    value: "",
  });

  const handleTransferClick = useCallback(async (transferExamId: string) => {
    setTransferExamId(transferExamId);
    setTransferPatient({ displayName: "", value: "" });
    setOpenTransferModal(true);
  }, []);

  const handleTransferClose = useCallback(() => {
    setOpenTransferModal(false);
    setTransferExamId("");
    setTransferPatient({ displayName: "", value: "" });
  }, []);

  return (
    <ExamTransferContext.Provider
      value={{
        openTransferModal,
        transferExamId,
        transferPatient,
        actions: {
          handleTransferClick,
          handleTransferClose,
          setTransferPatient,
        },
      }}
    >
      {children}
    </ExamTransferContext.Provider>
  );
};

export default ExamTransferProvider;
